<template>    
	<main class="main-wrapper flex-grow-1 with-footer dildarkhan" v-if="!examIntro">
		<!-- <div class="t-headline11 t-color-headlineBlack pda-16 t-center font-m">전체 강의</div> -->
 <div ref="examHeader">
		<view-header :paperData="paperData" :actions="actions" :examineeId="examineeId"></view-header>
	</div>
		<div class="divider"></div>
		<!-- subtabs -->
		<view-tab @setViewTab="setViewTab" :setTabFixed="setTabFixed"></view-tab>
		<div class="container container--narrow pdt-30">
			<!-- <div class="mgb-24" v-if="campaignData">
				<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
					<img :src="campaignData.image" alt="" v-if="campaignData.image" />
				</a>
				<a v-else href="javascript:void(0)" style="cursor:none">
						<img :src="campaignData.image" alt="">
					</a>
				</div> -->
				<component 
					:is="tabType"
					:periodPolicy="periodPolicy"
					:summary="summary"
					:pointPolicy="pointPolicy"
					:badges="badges"
			></component>
		</div>
    <!-- Updated By jungnam.lee@emcast.com desc -> duplicate calls -->
<!--		<router-view></router-view>-->
</main>
  <transition name="fade" mode="out-in" v-else>
				<router-view></router-view>
			</transition>
	<!-- <view-footer
		:paperData="paperData"
		:setTabFixed="setTabFixed"
	></view-footer> -->

</template>

<script>
/**
 * 단독 시험 나의 시험 상세 메인 컴포넌트(independent my exam view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import ViewHeader from './view/Header'
import ViewFooter from './view/Footer'
import ViewTab from './view/ViewTab'
import ViewInformation from './view/Information'
import ViewReward from './view/Reward'

export default {
	data() {
		return {
			examineeId: null,
			paperData: null,
			tabType: 'Information',
			setTabFixed: false,

			periodPolicy: null,
			summary: '',
			pointPolicy: null,
			badges: null,

			actions: null,
			examIntro : false
		}
	},
	components: {
		'view-header': ViewHeader,
		'view-footer': ViewFooter,
		'view-tab': ViewTab,
		'Information': ViewInformation,
		'Reward': ViewReward,
	},

	mounted() {
	//	console.log(this.$route, ' ___this.$route.___')
		if(this.$route.name === 'IndependentExamIntro' || this.$route.name === 'IndependentExamTake'){
			this.examIntro = true;
		}
		else{
			this.examIntro = false;
		}
		this.examineeId = this.$route.params.examineeId
		let params = {
			examineeId: this.examineeId,
			application: false
		}

		// get examinee view information
		examApi.independentExamineeExamView(params).then((response) => {
			this.paperData = response.data.data
			
			this.periodPolicy = this.paperData.period
			this.summary =  this.paperData.summary
			this.pointPolicy = this.paperData.point
			
		})

		// get exam intro action
		examApi.examIntro(params).then((response) => {
			this.actions = response.data.data.actions
		})

		// get exam badge list
		examApi.badges(params).then((response) => {
			this.badges = response.data.data
		})
	},

	methods: {
		setViewTab(tabType) {
			
			this.tabType = tabType
		},

		// 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
		scrollMove(el) {
			if (parseInt(el.scrollTop) >= parseInt(this.$refs.examHeader.offsetHeight)) {
				this.setTabFixed = true
			}else {
				this.setTabFixed = false
			}
		},
	}
}
</script>
<style scoped>
	#app{
		background: red !important;
	}
</style>